export default __webpack_public_path__ + "static/media/1289.e2b7af3a.png";